<ng-container [formGroup]="form">
    <div class="form-row">
        <div class="form-group" [ngClass]="(config.controlType === 'textarea') ? 'col-md-12' : 'col-md-6'">
            <label [ngClass]="{'required': config.required}">{{config.label}}</label>
            <ng-container [ngSwitch]="config.controlType">
                <input *ngSwitchCase="'textbox'" class="form-control" [formControlName]="config.key"
                    type="text" placeholder="{{config.placeholder}}" [ngClass]="{ 'is-invalid': isInValid }" />

                <ng-container *ngSwitchCase="'number'">
                    <input *ngIf="config.key == 'expected_weight'; else inputNormal" mask="separator.2" class="form-control" [formControlName]="config.key" type="text"
                    placeholder="{{config.placeholder}}" [ngClass]="{ 'is-invalid': isInValid }" />
                    <ng-template #inputNormal>
                        <input class="form-control" [formControlName]="config.key" type="number"
                    placeholder="{{config.placeholder}}" [ngClass]="{ 'is-invalid': isInValid }" />
                    </ng-template>
                </ng-container>


                <textarea *ngSwitchCase="'textarea'" class="form-control" type="text" [formControlName]="config.key"
                    rows="3" placeholder="{{config.placeholder}}" [ngClass]="{ 'is-invalid': isInValid }"></textarea>

                <ng-select notFoundText="{{'No items found' | translate}}" *ngSwitchCase="'dropdown'" [items]="config.options" bindLabel="name" bindValue="id"
                    [formControlName]="config.key" placeholder="{{config.placeholder}}"
                    [ngClass]="{ 'is-invalid': isInValid }">
                </ng-select>

            </ng-container>
            <span *ngIf="config.key == 'expected_weight'" class="span-label-ew">Kg</span>
            <span *ngIf="config.key == 'desired_temp'" class="span-label-ew">°C</span>
            <small *ngIf="isInValid" class="form-text text-danger">{{'You must enter a value' | translate}}</small>
        </div>
    </div>
</ng-container>
